"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _SubMenu = _interopRequireDefault(require("../Menu/SubMenu"));

var _default = _SubMenu.default;
exports.default = _default;